import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SiteInductionPage } from './components/site-induction/site-induction.page';
import { VisitorSignOutComponent } from './components/visitor-sign-out/visitor-sign-out.component';
import { FormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { InterceptorService } from './services/interceptor.service';
import * as SentryAngular from '@sentry/angular';
import { SentryErrorTesterComponent } from './components/sentry-error-tester/sentry-error-tester.component';

@NgModule({
  declarations: [
    AppComponent,
    SiteInductionPage,
    VisitorSignOutComponent,
    SentryErrorTesterComponent,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      swipeBackEnabled: false,
      innerHTMLTemplatesEnabled: true,
    }),
    AppRoutingModule,
    FormsModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler({
        showDialog: false, // not required for Kiosk App
      }),
    },
    {
      provide: SentryAngular.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [SentryAngular.TraceService],
      multi: true,
    },
    // Angular 18 replaced HttpClientModule with this provider. withInterceptorsFromDi
    // keeps the existing HTTP_INTERCEPTORS class interceptor above working.
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
